import {Link} from "react-router-dom";
import Icon from "../../components/selfcare/Icon.tsx";
import React from "react";
import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";
import Routing from "../../Routing.ts";
import ChatBotBoxComponent from "../../components/ChatBotBoxComponent.tsx";
import IconArrow from "../../components/icons/IconArrow.tsx";

export default function ContactPageLayout(props: {
    meta_title: string,
    meta_description: string,
    title: string,
    className: string,
    content: React.ReactNode
}) {
    setTitleAndMetaDescription("Kontakt - " + props.meta_title, props.meta_description)

    return (
        <div className={props.className}>
            <section className={'content'}>
                <div className={'header'}>
                    <h1 className={'heading heading--montserrat heading--big'}>{props.title}</h1>
                    <p>
                        <Link to={Routing.Contact.Index} className={'icon-link icon-link-left icon-link-rotate-180 back-link-widget'}>
                            <Icon component={IconArrow}/> <span className={'text'}>Tilbage</span>
                        </Link>
                    </p>
                </div>
            </section>

            {props.content}

            <ChatBotBoxComponent/>
        </div>
    )
}
